import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import IconButton from '@material-ui/core/IconButton'
import { ArrowBack, ExitToApp } from '@material-ui/icons'
import { Row, Col } from 'react-flexbox-grid'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import HelpIcon from '@material-ui/icons/Help'

import * as sessionActions from '../../reducers/SessionReducer/actions'
import { usuarioSelector } from '../../selectors/sessionSelector'

const styles = {
  list: {
    width: 300
  },
  fullList: {
    width: 'auto'
  },
  centerComponent: {
    justifyContent: 'center',
    alignItems: 'center'
  }
}

const MyDrawer = ({ classes, preguntasFrecuentes, usuario, handleOnCerrarSesion, handleOnClickIniciarSesion, drawerOpen, handleDrawerClose, handleOnClickLogo, instalacion }) => {
  return (
    <Drawer
      open={drawerOpen}
      onClose={handleDrawerClose}
      className='drawer'
    >
      <div>
        <Row style={{ margin: '0px' }}>
          <Col xs={2} ></Col>
          <Col xs={7} className='logoContainer center' style={{ textAlign: 'center' }}>
              <img alt='' onClick={() => { handleOnClickLogo() }} src={instalacion.logoDrawer} />
          </Col>
          <Col xs={3} >
            <div style={{ display: 'flex', height: '100%' }}>
              <IconButton
                color="default"
                aria-label="Close drawer"
                onClick={handleDrawerClose}
                className='headerButton'
              >
                <ArrowBack className='iconItemMenu'/>
              </IconButton>
            </div>
          </Col>
        </Row>
      </div>
      <div
        tabIndex={0}
        role="button"
      >
            <div className={classes.list}>
      <List className='menuItem'>
            <ListItem
                button key='PreguntasFrecuentes'
                >
                <ExpansionPanel style={{ boxShadow: 'none', borderRadius: '8px', maxWidth: '270px' }}>
                  <ExpansionPanelSummary
                      className=''
                      expandIcon={<ExpandMoreIcon className='iconItemMenu'/>}
                      aria-controls={'panelPreguntasFrecuentesa-content'}
                      id={'panelPreguntasFrecuentesa-header'}
                      style={{ padding: '0px', alignItems: 'center' }}
                      >
                        <ListItemIcon><HelpIcon className='iconItemMenu'/></ListItemIcon>
                        <ListItemText className='labelText' primary='Preguntas Frecuentes'/>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails style={{ padding: '0px' }}>
                    <div id='scrollItemsPF' className='containerPF'>
                      {preguntasFrecuentes && preguntasFrecuentes.length > 0 &&
                        preguntasFrecuentes.map((pf, i) => {
                          return <ExpansionPanel key={pf.idContenido} style={{ boxShadow: 'none' }}>
                                  <ExpansionPanelSummary
                                      className='panelPregunta'
                                      expandIcon={<ExpandMoreIcon className='iconItemMenu'/>}
                                      aria-controls={`panelPf${i}-content`}
                                      id={`panelPf${i}-header`}
                                      style={{ padding: '0px' }}
                                      >
                                        <Typography className={`${classes.heading} textPregunta`}>{pf.textoCorto}</Typography>
                                  </ExpansionPanelSummary>
                                  <ExpansionPanelDetails style={{ padding: '0px' }}>
                                    <Typography className={`${classes.heading} textRespuesta`}>{pf.textoLargo}</Typography>
                                  </ExpansionPanelDetails>
                              </ExpansionPanel>
                        }
                        )
                      }
                    </div>
                  </ExpansionPanelDetails>
              </ExpansionPanel>
            </ListItem>
      </List>
      <Divider />
      <List className='menuItem'>
            {usuario !== undefined && <ListItem
              button key='cerrarSesion'
              onClick={() => { handleOnCerrarSesion() }}
            >
                <ListItemIcon><ExitToApp className='iconItemMenu'/></ListItemIcon>
                <ListItemText className='labelText' primary='Cerrar sesión' />
            </ListItem>}

            {usuario === undefined &&
            <ListItem
                button key='iniciarSesion'
                onClick={() => { handleOnClickIniciarSesion() }}
              >
                  <ListItemIcon><ExitToApp className='iconItemMenu'/></ListItemIcon>
                  <ListItemText className='labelText' primary='Iniciar sesión' />
              </ListItem>
            }
      </List>
    </div>
      </div>
    </Drawer>
  )
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...sessionActions
  }, dispatch)
}

function mapStateToProps (state) {
  return {
    dataUser: usuarioSelector(state)

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MyDrawer))
